export const PRODUCTINVENTORYDETAIL_LOADING = "PRODUCTINVENTORYDETAIL_LOADING";
export const PRODUCTINVENTORYDETAIL_RESET = "PRODUCTINVENTORYDETAIL_RESET";
export const GET_PRODUCTINVENTORYDETAIL = "GET_PRODUCTINVENTORYDETAIL";
export const GET_PRODUCTINVENTORYDETAIL_SUCCESS = "GET_PRODUCTINVENTORYDETAIL_SUCCESS";
export const GET_PRODUCTINVENTORYDETAIL_FAIL = "GET_PRODUCTINVENTORYDETAIL_FAIL";
export const DELETE_PRODUCTINVENTORYDETAIL = "DELETE_PRODUCTINVENTORYDETAIL"
export const DELETE_PRODUCTINVENTORYDETAIL_SUCCESS = "DELETE_PRODUCTINVENTORYDETAIL_SUCCESS"
export const DELETE_PRODUCTINVENTORYDETAIL_FAIL = "DELETE_PRODUCTINVENTORYDETAIL_FAIL"
export const UPDATE_PRODUCTINVENTORYDETAIL = "UPDATE_PRODUCTINVENTORYDETAIL"
export const UPDATE_PRODUCTINVENTORYDETAIL_SUCCESS = "UPDATE_PRODUCTINVENTORYDETAIL_SUCCESS"
export const UPDATE_PRODUCTINVENTORYDETAIL_FAIL = "UPDATE_PRODUCTINVENTORYDETAIL_FAIL"
export const ADD_NEW_PRODUCTINVENTORYDETAIL = "ADD_NEW_PRODUCTINVENTORYDETAIL"
export const ADD_PRODUCTINVENTORYDETAIL_SUCCESS = "ADD_PRODUCTINVENTORYDETAIL_SUCCESS"
export const ADD_PRODUCTINVENTORYDETAIL_FAIL = "ADD_PRODUCTINVENTORYDETAIL_FAIL"